import React, { useState, useEffect, useCallback } from "react";
import axios from "axios";
import { useAuth } from "../../../services/useAuth";
import { Table, Tr, Td } from "../../BaseUI/Table";
import Checkbox from "../../BaseUI/Checkbox";
import Input from "../../BaseUI/Input";
import {
  API_URL,
  PREFERENCE_EVENT_TYPES,
} from "../../../views/pages/Notifications/constants";

const prefColumns = [
  { name: "Bildirim Türü", dataType: "text", id: 0 },
  { name: "Uygulama İçi", id: 1, sortable: false },
  { name: "E-posta", id: 2, sortable: false },
  { name: "Anlık Bildirim", id: 3, sortable: false },
  { name: "Sessize Al", id: 4, sortable: false },
  { name: "Sessizlik Bitiş Tarihi", id: 5, sortable: false },
];

const NotificationPreferences = () => {
  const { getToken } = useAuth();
  const [prefs, setPrefs] = useState({});
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(null);

  const authHeaders = useCallback(
    () => ({ headers: { Authorization: `Bearer ${getToken()}` } }),
    [getToken],
  );

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const { data } = await axios.get(
        `${API_URL}/api/notifications/preferences`,
        authHeaders(),
      );
      if (data.status) {
        const map = {};
        (data.preferences || []).forEach((p) => {
          map[p.eventType] = p;
        });
        setPrefs(map);
      }
    } finally {
      setLoading(false);
    }
  }, [authHeaders]);

  useEffect(() => {
    load();
  }, [load]);

  const getPref = (eventType) =>
    prefs[eventType] || {
      inApp: true,
      email: false,
      push: true,
      muted: false,
      mutedUntil: "",
    };

  const updatePref = async (eventType, patch) => {
    const current = getPref(eventType);
    const updated = { ...current, ...patch, eventType };
    setPrefs((p) => ({ ...p, [eventType]: updated }));

    setSaving(eventType);
    try {
      await axios.put(
        `${API_URL}/api/notifications/preferences`,
        updated,
        authHeaders(),
      );
    } finally {
      setSaving(null);
    }
  };

  return (
    <div>
      <p className="text-muted small mb-3">
        Hangi bildirimleri almak istediğinizi buradan seçebilirsiniz. E-posta bildirimleri için SMTP ayarlarının yapılmış olması gerekir.
      </p>
      <Table columns={prefColumns} loading={loading} search={false}>
        {PREFERENCE_EVENT_TYPES.map(({ key, label, description }) => {
          const p = getPref(key);
          const isSaving = saving === key;
          return (
            <Tr key={key}>
              <Td>
                <strong style={{ fontSize: "0.875rem" }}>{label}</strong>
                {description && (
                  <div className="text-muted small">{description}</div>
                )}
                {isSaving && <span className="text-muted small ms-2">Kaydediliyor...</span>}
              </Td>
              <Td>
                <Checkbox
                  isChecked={!!p.inApp}
                  onChange={() => updatePref(key, { inApp: !p.inApp })}
                />
              </Td>
              <Td>
                <Checkbox
                  isChecked={!!p.email}
                  onChange={() => updatePref(key, { email: !p.email })}
                />
              </Td>
              <Td>
                <Checkbox
                  isChecked={!!p.push}
                  onChange={() => updatePref(key, { push: !p.push })}
                />
              </Td>
              <Td>
                <Checkbox
                  isChecked={!!p.muted}
                  onChange={() => updatePref(key, { muted: !p.muted })}
                />
              </Td>
              <Td>
                <Input
                  type="datetime-local"
                  value={p.mutedUntil ? new Date(p.mutedUntil).toISOString().slice(0, 16) : ""}
                  disabled={!p.muted}
                  onChange={(v) => updatePref(key, { mutedUntil: v || null })}
                />
              </Td>
            </Tr>
          );
        })}
      </Table>
    </div>
  );
};

export default NotificationPreferences;
